const toCurrencyString = value => {
  if (value !== undefined) {
    var delimiter = "."; // replace comma if desired
    var a = value.split('.',2)
    console.log('value :' + value);
    console.log('a :' + a);
    var d = a[1];
    var i = parseInt(a[0]);
    if(isNaN(i)) { return ''; }
    var minus = '';
    if(i < 0) { minus = '-'; }
    i = Math.abs(i);
    var n = new String(i);
    var a = [];
    while(n.length > 3) {
      var nn = n.substr(n.length-3);
      a.unshift(nn);
      n = n.substr(0,n.length-3);
    }
    if(n.length > 0) { a.unshift(n); }
    n = a.join(delimiter);
    if(d.length < 1) { value = n; }
    else { value = n + ',' + d; }
    value = minus + value;
    return value;
  }

  return '-'
}

export { toCurrencyString };
